import { DropboxOutlined } from "@ant-design/icons";
import { type FunctionComponent } from "react";
import { Blue7 } from "styles/antTheme/Colors";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconDropboxOutlined: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return <DropboxOutlined {...props} style={{ ...props.style, color: Blue7 }} />;
};
